import { useState, useEffect, useRef, useCallback } from "react";
import { StyledTextBox } from "./styles";

import assets from "../../assets";

interface MessageInputProps {
  threadUid: string | string[] | undefined;
  handleSendMessage: (newMessage: string, imageFile?: File | null) => void;
  error: string | null;
}

export const MessageInput = ({
  threadUid,
  handleSendMessage,
  error,
}: MessageInputProps) => {
  const [message, setMessage] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const togglePlaceholderVisibility = useCallback((): void => {
    const isEmpty = !message.trim();
    if (inputRef.current) {
      inputRef.current.classList.toggle("placeholder-visible", isEmpty);
    }
  }, [message]);

  useEffect(() => {
    togglePlaceholderVisibility();
  }, [togglePlaceholderVisibility]);

  const handleMessageChange = (): void => {
    const text = inputRef.current?.innerText || "";
    setMessage(text.trim());
    togglePlaceholderVisibility();
  };

  const handleFocus = (): void => {
    togglePlaceholderVisibility();
  };

  const handleBlur = (): void => {
    togglePlaceholderVisibility();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // Prevents creating a new line
      sendMessage();
    } else if (event.key === "Backspace" && !message.trim()) {
      togglePlaceholderVisibility();
    }
  };

  const sendMessage = (): void => {
    if (message.trim() || imageFile) {
      handleSendMessage(message, imageFile);
      setMessage("");
      setImageFile(null);
      if (inputRef.current) {
        inputRef.current.innerText = "";
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset file input
      }
      togglePlaceholderVisibility();
    }
  };

  return (
    <StyledTextBox>
      <div
        className={`textbox ${!message.trim() ? "placeholder-visible" : ""}`}
        role="textbox"
        contentEditable
        tabIndex={0}
        spellCheck
        data-placeholder="Type your message here..."
        ref={inputRef}
        onInput={handleMessageChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      ></div>
      {/*<button onClick={openFilePicker} style={{ left: "0px" }}>
        <img alt="" src={assets.BellIcon} height={16} width={16} />
      </button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        onChange={handleImageUpload}
      />*/}
      <button onClick={sendMessage}>
        <img alt="" src={assets.SendVector} height={16} width={16} />
      </button>
    </StyledTextBox>
  );
};
